export enum TipoSolicitud {
	Inscripcion = 1,
	Renovacion = 2,
	Suspension = 4,
	Reactivacion = 5,
	Cancelacion = 6,
	Actualizacion = 7,
	ReactivacionAnticipada = 9
}
